// Shared password policy used by ChangePasswordModal and EmployeeForm.
// Mirrors the backend rules in ChangePasswordRequest / EmployeeDto.
export const PASSWORD_MIN_LENGTH = 6;
export const NO_EDGE_WHITESPACE_REGEX = /^\S(?:[\s\S]*\S)?$/;
